import React, { FunctionComponent } from 'react';
import { Button } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

import SelectModel from '../shared/SelectModel';
import SelectModelInstance from '../shared/SelectModelInstance';

import { SourceDropDown } from '../../types/models';

import IOSelect from './IOSelect';

interface IOConsolidationNavigationProps {
  clientId: number;
  modelId?: number;
  modelInstanceId?: number;
  source?: SourceDropDown;
  onModelChange: (id: number) => void;
  onModelInstanceChange: (id: number) => void;
  onSourceChange: (source: SourceDropDown) => void;
  onGenerateReport: () => void;
}

const IOConsolidationNavigation: FunctionComponent<
  IOConsolidationNavigationProps
> = ({
  clientId,
  modelId,
  modelInstanceId,
  source,
  onModelChange,
  onModelInstanceChange,
  onSourceChange,
  onGenerateReport,
}) => {
  return (
    <Grid container sx={{ alignItems: 'center' }} spacing={2}>
      <Grid sm={2.5}>
        <SelectModel
          clientId={clientId}
          modelId={modelId}
          onChange={onModelChange}
          size="small"
        />
      </Grid>
      <Grid sm={2.5}>
        <SelectModelInstance
          clientId={clientId}
          modelId={modelId}
          modelInstanceId={modelInstanceId}
          onChange={onModelInstanceChange}
          size="small"
        />
      </Grid>
      <Grid sm={2.5}>
        <IOSelect
          disabled={modelInstanceId === undefined}
          source={source}
          onChange={onSourceChange}
          size="small"
        />
      </Grid>
      <Grid container justifyContent="flex-end" sm={4.5}>
        <Button
          variant="contained"
          size="medium"
          onClick={onGenerateReport}
          disabled={!source}
        >
          Generate Report
        </Button>
      </Grid>
    </Grid>
  );
};

export default IOConsolidationNavigation;
